import API from '@/api'
import router from '@/router/index.js'
import { getToken, setToken, removeToken, getMenus, setMenus, removeMenus, getUserInfo, setUserInfo, removeUserInfo, removeIsCollapse, 
  getTabs, setTabs, removeTabs, getActiveTab } from '@/utils/auth'

const RESET_STATE = 'RESET_STATE'
const SET_TOKEN = 'SET_TOKEN'
const SET_MENUS = 'SET_MENUS'
const SET_USER_INFO = 'SET_USER_INFO'

let getDefaultState = () => ({
  token: getToken() || '',
  menus: getMenus() || [],
  userInfo: getUserInfo() || {},
  tabs: getTabs() || [],
  // [
    // {
    //   key: '/dashboard',
    //   name: 'dashboard',
    //   path: '/dashboard',
    //   query: {}
    // }
  // ],
  activeTab: {},
  // {
  //   key: '/dashboard',
  //   name: 'dashboard',
  //   path: '/dashboard',
  //   query: {}
  // },
})

let state = getDefaultState()

let mutations = {
  [RESET_STATE]: (state) => {
    Object.assign(state, getDefaultState())
  },
  [SET_TOKEN]: (state, token) => {
    state.token = token
  },
  [SET_MENUS]: (state, menus) => {
    state.menus = menus
  },
  [SET_USER_INFO]: (state, userInfo) => {
    state.userInfo = userInfo
  },
  addTab(state, tab) {
    const has = state.tabs.some((item) => {
      const bool = item.key === tab.key
      if (bool) item.query = tab.query // 更新query
      return bool
    })
    if (!has) state.tabs.push(tab)
    state.activeTab = tab
    setTabs(state.tabs)
  },
  setActiveTab(state, key) {
    if (state.activeTab.key === key) {
      return
    }
    const tabs = [...state.tabs]

    for (const i in tabs) {
      if (tabs[i].key === key) {
        router.push({
          path: tabs[i].path,
          query: tabs[i].query
        })
        state.activeTab = tabs[i]
        break
      }
    }
  },
  /**
   * 删除tab
   * @param {*} state
   * @param {Object} data { key: String（删除tab的key）, isJump: Boolean（是否跳转路由）, path: String(跳转的路由地址，如果不传此参数，默认跳转到最后一个tab), query: Object(跳转参数)}
   * @returns
   */
   deleteTab(state, data) {
    const tabs = [...state.tabs]

    if (tabs.length <= 1) return
    if (!data.key) data.key = state.activeTab.key // 如果不传key，则默认删除当前tab
    for (const i in tabs) {
      if (tabs[i].key === data.key) {
        tabs.splice(i, 1)
        break
      }
    }
    state.tabs = tabs
    setTabs(state.tabs)
    if (data.isJump && state.activeTab.key === data.key) {
      router.push({
        path: data.path ? data.path : state.tabs[state.tabs.length - 1].path,
        query: data.query ? data.query : state.tabs[state.tabs.length - 1].query
      })
    }
  },
}

let actions = {
  setToken({ commit }, token) {
    setToken(token)
    commit(SET_TOKEN, token)
  },

  setUserInfo({ commit }, userInfo) {
    setUserInfo(userInfo)
    commit(SET_USER_INFO, userInfo)
  },

  getUserPerissions({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      API.getRoleResources()
        .then((response) => {
          let { data, code, message } = response
          if (code === 10000) {
            setMenus(data)
            commit(SET_MENUS, data)
            let userInfo = getUserInfo()
            if (userInfo) {
              userInfo.isGetPermission = 1
              dispatch('setUserInfo', userInfo)
            }
            resolve(data)
          } else {
            reject(message)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  logout({ dispatch }) {
    return dispatch('resetToken')
  },

  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken() // 必须首先删除Token
      removeMenus()
      removeUserInfo()
      removeIsCollapse()
      removeTabs()
      commit(RESET_STATE)
      resolve()
    })
  },

  setTabs({ commit }, tabs) {
    setTabs(tabs)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
